<template>
  <TutorialView
    :cards="cards"
    game="quiz"
  />
</template>

<script>
import TutorialView from '@/components/games/tutorial/TutorialView.vue';

export default {
  name: 'QuizTutorial',
  components: {
    TutorialView,
  },
  data: () => ({
    cards: [
      {
        text: 'GAME.QUIZ.TUTORIAL.HOW_DO_YOU_REACT',
      },
      {
        text: 'GAME.QUIZ.TUTORIAL.CHOOSE_YOUR_ANSWER',
      },
    ],
  }),
  // created() {
  //   // Add pre-form
  //   this.cards.push({
  //     text: 'GAME.QUIZ.TUTORIAL.BEFORE_STARTING',
  //     form: this.$store.getters['evaluate/byScreen']('quiz'),
  //   });
  // },
};
</script>
